<script>
import { hasAdminRole } from '@/api/Utilities.js'
import { getMyUserId } from '@/api/FirebaseUserWrapper.js'

// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
const analytics = getAnalytics(firebaseApp)
require('@/css/style.css')
export default {
  components: {},
  data () {
    return {
      userId: ''
    }
  },
  async created () {
    this.userId = await getMyUserId()
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.userId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'aboutTree/aboutTree')
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.about {
  margin: auto;
  max-width: 1024px;
  padding: 1.0rem;
}
.is-rounded {
  border: 1px solid #999999;
  border-radius: 10px;
}
.subfooter {
  background-color: #191970;
  color: #fff;
  width: auto;
  padding: 3rem 1.5rem 6rem
}
</style>
<template>
  <div class="about">
    <div class="tabs is-left is-small">
      <ul>
        <li>
          <router-link to="/about">概要</router-link>
        </li>
        <li>
          <router-link to="/about/team">チームについて</router-link>
        </li>
        <li class="is-active">
          <router-link to="/about/tree">ツリーについて</router-link>
        </li>
        <li>
          <router-link to="/about/node">ふせんについて</router-link>
        </li>
      </ul>
    </div>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">ツリーの概要</p>
        <p class='text'>
          ツリー形状のふせんボードを作ることでチームメンバーの状況を全体を見通して把握できます。<br>
          個別のふせんに対してコメントを追加することでどの話題からでもチャットを開始できます。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded" src="./img/tree_graph.png">
      </div>
    </div>
    <hr>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">ツリーの追加</p>
        <p class='text'>
          サイドバーのチーム一覧から「Treeの作成」ボタンを押します。<br>
          ツリーの名前を記載することでツリーを作成することができます。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded" src="./img/tree_make.png">
      </div>
    </div>
    <hr>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">ツリーの更新</p>
        <p class='text'>
          サイドバーのツリーは「更新」ボタンを押すことで最新に更新できます。<br>
          あなたや仲間がツリーを立てた場合には更新で最新を取得しましょう。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded" src="./img/tree_update.png">
      </div>
    </div>
    <br>
    <div class="subfooter">
      <div class="content has-text-centered is-size-7">
        <div class="columns is-multiline is-mobile">
          <div class="column is-half">
            <router-link to="teams" class="has-text-white">
              <p>開発チーム</p>
            </router-link>
          </div>
          <div class="column">
            <router-link to="terms" class="has-text-white">
              <p>利用規約</p>
            </router-link>
          </div>
        </div>
        <div class="columns is-multiline is-mobile">
          <div class="column is-half">
            <router-link to="privacy" class="has-text-white">
              <p>プライバシー</p>
            </router-link>
          </div>
          <div class="column">
            <router-link to="contact" class="has-text-white">
              <p>お問合せ</p>
            </router-link>
          </div>
        </div>
        <p>@socialup</p>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/about/tutorial/AboutTree.vue